<template>
  <div class="group-buy-detail">
    <!-- 返回按钮 -->
    <header class="detail-header">
      <button class="back-btn" @click="goBack">&lt; 返回</button>
      <h2>商品详情</h2>
    </header>

    <!-- 商品图片 -->
    <div class="product-image">
      <img :src="product.image" :alt="product.title" />
    </div>

    <!-- 价格信息 -->
    <div class="price-section">
      <div class="price-row">
        <span class="current-price">¥{{ product.currentPrice }}</span>
        <span class="original-price">¥{{ product.originalPrice }}</span>
        <span class="discount-tag">{{ discount }}折</span>
      </div>
      <p class="sales-info">已售 {{ product.joinedCount }} 件</p>
    </div>

    <!-- 商品信息 -->
    <div class="product-info">
      <h1 class="product-title">{{ product.title }}</h1>
      <p class="product-desc">{{ product.description }}</p>
    </div>

    <!-- 团购进度 -->
    <div class="group-progress">
      <h3>团购进度</h3>
      <div class="progress-bar">
        <div class="progress" :style="{ width: product.progress + '%' }"></div>
      </div>
      <div class="progress-info">
        <span>已参团 {{ product.joinedCount }}/{{ product.targetCount }}</span>
        <span class="time-left">{{ product.timeLeft }}</span>
      </div>
    </div>

    <!-- 团长信息 -->
    <div class="leader-section">
      <h3>团长信息</h3>
      <div class="leader-card">
        <img :src="product.leaderAvatar" class="leader-avatar" />
        <div class="leader-info">
          <p class="leader-name">{{ product.leaderName }}</p>
          <p class="leader-stats">已开团 {{ product.leaderGroups }} 次</p>
        </div>
        <button class="call-leader-btn" @click="callLeader">
          📞 联系团长
        </button>
      </div>
    </div>

    <!-- 商家信息 -->
    <div class="merchant-section">
      <h3>商家信息</h3>
      <div class="merchant-card">
        <img :src="product.merchantAvatar" class="merchant-avatar" />
        <div class="merchant-info">
          <p class="merchant-name">{{ product.merchantName }}</p>
          <p class="merchant-rating">评分: {{ product.merchantRating }}</p>
        </div>
        <button class="call-merchant-btn" @click="callMerchant">
          📞 联系商家
        </button>
      </div>
    </div>

    <!-- 商品详情描述 -->
    <div class="detail-content">
      <h3>商品详情</h3>
      <div class="content-text">
        <p>{{ product.detailDescription }}</p>
      </div>
    </div>

    <!-- 参团记录 -->
    <div class="join-records">
      <h3>参团记录</h3>
      <div class="record-list">
        <div v-for="record in joinRecords" :key="record.id" class="record-item">
          <img :src="record.avatar" class="user-avatar" />
          <div class="record-info">
            <p class="user-name">{{ record.name }}</p>
            <p class="join-time">{{ record.time }}</p>
          </div>
          <button class="call-user-btn" @click="callUser(record)">
            📞 联系
          </button>
        </div>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="bottom-actions">
      <button class="share-btn" @click="shareProduct">
        分享好友
      </button>
      <button class="join-btn" @click="joinGroup">
        立即参团
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GroupBuyDetail',
  data() {
    return {
      product: {
        id: 1,
        title: '新鲜草莓 现摘现发 5斤装',
        description: '产地直供，新鲜直达，坏果包赔',
        image: 'https://images.unsplash.com/photo-1464965911861-746a04b4bca6?w=400&h=300&fit=crop',
        currentPrice: 39.9,
        originalPrice: 68.0,
        joinedCount: 156,
        targetCount: 200,
        progress: 78,
        timeLeft: '还剩2天',
        detailDescription: '我们的草莓来自优质产地，每天清晨采摘，当天发货。果实饱满，色泽鲜艳，口感甜美。采用专业包装，确保运输过程中的新鲜度。坏果包赔，让您购物无忧。',
        leaderName: '张三',
        leaderAvatar: 'https://i.pravatar.cc/60?img=10',
        leaderGroups: 23,
        leaderPhone: '13900139001',
        merchantName: '鲜果优选',
        merchantAvatar: 'https://i.pravatar.cc/60?img=1',
        merchantRating: 4.8,
        merchantPhone: '13800138001'
      },
      joinRecords: [
        { id: 1, name: '李四', avatar: 'https://i.pravatar.cc/40?img=11', time: '10分钟前', phone: '13900139002' },
        { id: 2, name: '王五', avatar: 'https://i.pravatar.cc/40?img=12', time: '30分钟前', phone: '13900139003' },
        { id: 3, name: '赵六', avatar: 'https://i.pravatar.cc/40?img=13', time: '1小时前', phone: '13900139004' },
        { id: 4, name: '孙七', avatar: 'https://i.pravatar.cc/40?img=14', time: '2小时前', phone: '13900139005' }
      ]
    };
  },
  computed: {
    discount() {
      return ((this.product.currentPrice / this.product.originalPrice) * 10).toFixed(1);
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    callMerchant() {
      window.location.href = `tel:${this.product.merchantPhone}`;
    },
    callLeader() {
      window.location.href = `tel:${this.product.leaderPhone}`;
    },
    callUser(record) {
      window.location.href = `tel:${record.phone}`;
    },
    shareProduct() {
      alert('分享功能演示：可以分享给微信好友或朋友圈');
    },
    joinGroup() {
      if (confirm('确认参团吗？')) {
        alert('参团成功！商家会尽快联系您。');
        this.$router.push({ name: 'MyGroupBuys' });
      }
    }
  }
};
</script>

<style scoped>
.group-buy-detail {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 80px;
}

.detail-header {
  background: white;
  padding: 15px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-btn {
  background: none;
  border: none;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  margin-right: 15px;
}

.detail-header h2 {
  margin: 0;
  font-size: 18px;
}

.product-image {
  width: 100%;
  height: 250px;
  background: white;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.price-section {
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  padding: 20px;
  color: white;
}

.price-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.current-price {
  font-size: 32px;
  font-weight: bold;
}

.original-price {
  font-size: 16px;
  text-decoration: line-through;
  opacity: 0.7;
}

.discount-tag {
  background: rgba(255,255,255,0.3);
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 14px;
}

.sales-info {
  margin: 0;
  font-size: 14px;
  opacity: 0.9;
}

.product-info {
  background: white;
  padding: 20px;
  margin-top: 10px;
}

.product-title {
  margin: 0 0 10px;
  font-size: 18px;
  color: #333;
}

.product-desc {
  margin: 0;
  font-size: 14px;
  color: #666;
}

.group-progress {
  background: white;
  padding: 20px;
  margin-top: 10px;
}

.group-progress h3 {
  margin: 0 0 15px;
  font-size: 16px;
  color: #333;
}

.progress-bar {
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress {
  height: 100%;
  background: linear-gradient(90deg, #ff6b6b, #ee5a6f);
  border-radius: 4px;
}

.progress-info {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}

.time-left {
  color: #ff6b6b;
  font-weight: bold;
}

.leader-section,
.merchant-section {
  background: white;
  padding: 20px;
  margin-top: 10px;
}

.leader-section h3,
.merchant-section h3 {
  margin: 0 0 15px;
  font-size: 16px;
  color: #333;
}

.leader-card,
.merchant-card {
  display: flex;
  align-items: center;
  gap: 15px;
}

.leader-avatar,
.merchant-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.leader-info,
.merchant-info {
  flex: 1;
}

.leader-name,
.merchant-name {
  margin: 0 0 5px;
  font-size: 16px;
  color: #333;
}

.leader-stats,
.merchant-rating {
  margin: 0;
  font-size: 13px;
  color: #999;
}

.call-leader-btn,
.call-merchant-btn {
  padding: 10px 20px;
  background: #fff0f0;
  border: 2px solid #ff6b6b;
  border-radius: 20px;
  color: #ff6b6b;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.call-leader-btn:hover,
.call-merchant-btn:hover {
  background: #ff6b6b;
  color: white;
}

.detail-content {
  background: white;
  padding: 20px;
  margin-top: 10px;
}

.detail-content h3 {
  margin: 0 0 15px;
  font-size: 16px;
  color: #333;
}

.content-text {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

.join-records {
  background: white;
  padding: 20px;
  margin-top: 10px;
}

.join-records h3 {
  margin: 0 0 15px;
  font-size: 16px;
  color: #333;
}

.record-list {
  max-height: 300px;
  overflow-y: auto;
}

.record-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.record-item:last-child {
  border-bottom: none;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.record-info {
  flex: 1;
}

.user-name {
  margin: 0 0 3px;
  font-size: 14px;
  color: #333;
}

.join-time {
  margin: 0;
  font-size: 12px;
  color: #999;
}

.call-user-btn {
  padding: 6px 12px;
  background: #fff0f0;
  border: 1px solid #ff6b6b;
  border-radius: 15px;
  color: #ff6b6b;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.call-user-btn:hover {
  background: #ff6b6b;
  color: white;
}

.bottom-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: white;
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
  padding: 10px 15px;
  gap: 10px;
}

.share-btn {
  flex: 1;
  padding: 15px;
  background: white;
  border: 2px solid #ff6b6b;
  border-radius: 25px;
  color: #ff6b6b;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.share-btn:hover {
  background: #fff0f0;
}

.join-btn {
  flex: 2;
  padding: 15px;
  background: linear-gradient(135deg, #ff6b6b, #ee5a6f);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
}

.join-btn:hover {
  opacity: 0.9;
}
</style>
